// extracted by mini-css-extract-plugin
export default {"text":"Message_text__TRU4x","isCurrent":"Message_isCurrent__kaH+d","isWinner":"Message_isWinner__QhqNU","winner":"Message_winner__HA9mc"};